<template>
  <div id="totalBox">
    <div class="otherBox">
      <div class="otherLockBox">
        <div class="lockImgBox">
          <img src="../../assets/product/lock.png" class="lockImg"/>
        </div>
        <div class="lockNameBox">
            <img src="../../assets/product/otherLeft.png" alt="" class="dricetionIcon"/>
          <div class="nameText">智能地锁</div>
        </div>
      </div>
    </div>
    <div class="netTotalBox">
      <div class="netBox">
        <div class="netNameBox">
          <div class="nameText">无线网关</div>
          <img src="../../assets/product/otherRight.png" alt="" class="netDricetionIcon"/>
        </div>
         <div class="netImgBox">
          <img src="../../assets/product/net.jpg" class="netImg"/>
        </div>
      </div>
    </div>
    <div class="doorBox">
      <div class="doorNameBox">
        <img src="../../assets/product/otherLeft.png" alt="" class="dricetionIcon"/>
        <div class="nameText">智能道闸</div>
      </div>
      <div class="doorImgBox">
        <img src="../../assets/product/door.png" class="doorImg"/>
      </div>
    </div>
    <div class="productImgBox">
      <div class="productImgList">
        <img src="../../assets/product/video.png" class="productImg" alt="" />
        <div class="productName">高位摄像头</div>
      </div>
      <div class="productImgList">
        <img src="../../assets/product/5g.png" class="productImg" alt="" />
        <div class="productName">5G充电桩</div>
      </div>
      <div class="productImgList">
        <img src="../../assets/product/magic.png" class="productImg" alt="" />
        <div class="productName">地磁</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CModel',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
}
.otherBox{
  margin-top: 36px;
}
.otherLockBox{
  width: 1200px;
  margin: 0 auto;
  height: 360px;
  background-color: #fff;
  position: relative;
}
.lockImgBox{
  border-radius:4px;
  width: 720px;
  height: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
}
.lockImg{
  width:680px;
  height:420px;
  float: left;
}
.lockNameBox{
  position: absolute;
  top: 80px;
  left: 749px;
  float: left;
  display: flex;
  align-items: center;
}

.nameText{
  font-size:30px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  margin: 0 10px;
}
.dricetionIcon{
  width:23px;
  height:25px;
  margin-left: 20px;
}
.netTotalBox{
  width: 100%;
  background-color: RGBA(247, 247, 247, 1);
  height: 580px;
}
.netBox{
  width: 1200px;
  height: 580px;
  margin: 0 auto;
  position: relative;
}
.netNameBox{
  position: absolute;
  top: 195px;
  left: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.netImgBox{
  width: 556px;
  height: 726px;
  border-radius:4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  position: absolute;
  top: -175px;
  right: 0;
}
.netDricetionIcon{
  width:23px;
  height:25px;
  margin-right: 20px;
}
.netImg{
  width:516px;
  height:686px;
}
.doorBox{
  width: 1200px;
  margin: 0 auto;
  height: 260px;
  position: relative;
}
.doorImgBox{
  width: 720px;
  height: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius:4px;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: -220px;
}
.doorImg{
  width: 680px;
  height: 420px;
}
.doorNameBox{
  position: absolute;
  right: 255px;
  top: 73px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.productImgBox{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 69px;
}
.productImg{
  width: 380px;
  height: 480px;
}
.productName{
  font-size:28px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  margin-top: 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/other.vue